export const tarifs = [
    {
        title: "Tarif plein sans audioguide (Smart Visit incluse) et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "17,00€"
    },
    {
        title: "Tarif audioguide",
        price: "3,00€"
    },
    {
        title: "Tarif résident sans audioguide (Smart Visit incluse) et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "10,00€",
        note: "Sur présentation d'un justificatif de domicile"
    },
    {
        title: "Jusqu'à 5 ans",
        price: "Gratuit",
        note: "Accompagné des parents"
    },
    {
        title: "Tarif enfant de 6 à 12 ans et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "3,00€",
        note: "Accompagné des parents – avec livret de visite"
    },
    {
        title: "Tarif jeune de 13 à 17 ans et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "5,00€",
        note: "Accompagné des parents"
    },
    {
        title: "Tarif étudiant et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "8,00€",
        note: "Sur présentation de la carte étudiante"
    },
    {
        title: "Tarif étudiant",
        price: "5,00€",
        note: "Sur présentation de la carte étudiante"
    },
    {
        title: "Tarif sénior et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "12,00€",
        note: "+ de 65 ans"
    },
    {
        title: "Tarif réduit et accès aux expositions temporaires (lorsqu'il y en a)",
        price: "12,00€",
        note: "Sur présentation d'un justificatif en cours de validité",
        sublistTitle: "Peuvent bénéficier du tarif réduit :",
        sublist: [
            "Les personnes handicapées et un accompagnateur (carte d'invalidité)",
            "Les anciens combattants (carte valide)",
            "Les enseignants de l'Éducation nationale en activité, sur présentation du « Pass Éducation »",
            "Les artistes professionnels (carte en cours de validité)"
        ]
    },
    {
        title: "Tarif solidarité",
        price: "3,00€",
        note: "Pour les bénéficiaires des minima sociaux et les demandeurs d'emploi, sur présentation d'un justificatif de moins de 3 mois"
    },
    {
        title: "Dispositif de visite (livret de visite ou prêt d'un dispositif numérique, notamment pour la visite enfant)",
        price: "3,00€"
    }
];

export const tarifsNote = "Pour les tarifs de groupes et scolaires, se renseigner à l'accueil-billetterie ou à publics@macte.fr";
